import { render, staticRenderFns } from "./EntityImport.vue?vue&type=template&id=6be16edb"
import script from "./EntityImport.vue?vue&type=script&lang=js"
export * from "./EntityImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports